import React from "react";
import HeaderWithTag from "../../common/header_with_tag";
import ErrorCodesLink from "../../common/ErrorCodesLink";

function Appendix() {
  return (
    <div className="page">
      <div className="app-content main-content mt-0">
        <div className="side-app">
          <div className="main-container container-fluid">
            <div className="page-header">
              <div>
                <h1 className="page-title">Appendix</h1>
              </div>
              <div className="ms-auto pageheader-btn">
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="javascript:void(0);">Docs</a>
                  </li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Appendix
                  </li>
                </ol>
              </div>
            </div>


            <div className="card overflow-hidden">
              <div className="row">
                <div className="col-md-12" style={{ position: "relative" }}>
                  <div className="card-body border-end p-0">
                    <div className="p-5">

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Refund Type"
                          headerTag="refundType"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Refund Type</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Net</td>
                                <td>Net means without commission</td>
                              </tr>
                              <tr>
                                <td>Full</td>
                                <td>Full means with commission</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Mobile Entities"
                          headerTag="entity"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Entity</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>EDAHAB</td>
                                <td>Edahab Mobile Money</td>
                              </tr>
                              <tr>
                                <td>MPESA</td>
                                <td>Mpesa Mobile Money</td>
                              </tr>
                              <tr>
                                <td>UGANDA</td>
                                <td>Uganda Mobile Wallets</td>
                              </tr>
                              <tr>
                                <td>TANZANIA</td>
                                <td>Tanzania Mobile Wallets</td>
                              </tr>
                              <tr>
                                <td>BANGLADESH</td>
                                <td>Bangladesh Mobile Wallets</td>
                              </tr>
                              <tr>
                                <td>PESALink</td>
                                <td>PESALink &mdash; also valid with the bank account type</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Bank Entities"
                          headerTag="entity"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Entity</th>
                                <th>Description</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>DMT</td>
                                <td>Dahabshiil Money Transfer</td>
                              </tr>
                              <tr>
                                <td>DBI</td>
                                <td>Dahabshil Bank International</td>
                              </tr>
                              <tr>
                                <td>EAB</td>
                                <td>East African Bank</td>
                              </tr>
                              <tr>
                                <td>PESALink</td>
                                <td>PESALink &mdash; also valid with the wallet account type</td>
                              </tr>
                              <tr>
                                <td>ABC</td>
                                <td>ABC bank account transfers</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Document Type"
                          headerTag="documentType"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Document Type</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Passport</td>
                              </tr>
                              <tr>
                                <td>Driving License</td>
                              </tr>
                              <tr>
                                <td>National ID</td>
                              </tr>
                              <tr>
                                <td>Travel Document</td>
                              </tr>
                              <tr>
                                <td>Other</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Sender Type"
                          headerTag="senderType"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Sender Type</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>INDIVIDUAL</td>
                              </tr>
                              <tr>
                                <td>CORPORATE</td>
                              </tr>
                              <tr>
                                <td>CHARITY</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>

                      <div className="my-5">
                        <HeaderWithTag
                          headerText="Test Accounts"
                          headerTag="testAccounts"
                        />
                        <div className="table-responsive">
                          <table className="table text-nowrap text-md-nowrap table-bordered">
                            <thead>
                              <tr>
                                <th>Account Type</th>
                                <th>Account ID</th>
                                <th>Account Name</th>
                                <th>Country</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr>
                                <td>Edahab</td>
                                <td>252654249184</td>
                                <td>Abdirazak Ibrahim Abdirahman</td>
                                <td>Somalia</td>
                              </tr>
                              <tr>
                                <td>DBI</td>
                                <td>201015982801</td>
                                <td>Abdirazak Ibrahim Abdirahman</td>
                                <td>Somalia</td>
                              </tr>
                            </tbody>
                          </table>
                        </div>
                      </div>
                      <ErrorCodesLink />

                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Appendix;
